module.exports = __webpack_public_path__ + "static/media/blueWithdrawal.91d5124d.svg";